import React, { useState, useEffect } from 'react';
import { CheckIcon } from '../Icons';
import '../filterComponents.css';

const MultiCheckFilterTW = ({ type, label, filterKey, deletable, options, onFilterChange, currentValue }) => {
    const [selectedItems, setSelectedItems] = useState(currentValue?.map((item) => item.data[0]) || []);

    useEffect(() => {
        if (currentValue) {
            const newValues = currentValue.map((item) => item.data[0]);
            setSelectedItems(newValues);
        }
    }, [currentValue]);

    const handleChange = (value) => {
        let newSelectedItems;

        if (value === 'all') {
            newSelectedItems = selectedItems.length === options.length ? [] : [...options];
        } else {
            newSelectedItems = selectedItems.includes(value)
                ? selectedItems.filter((item) => item !== value)
                : [...selectedItems, value];
        }

        setSelectedItems(newSelectedItems);

        // Create individual chips for each selected item
        const filterData = newSelectedItems.map((item) => ({
            type,
            data: [item],
            chipLabel: `${label}: ${item}`,
            filterKey,
            deletable: deletable,
        }));

        onFilterChange(filterData.length === 0 ? null : filterData);
    };

    const isAllSelected = selectedItems.length === options.length;
    const someSelected = selectedItems.length > 0 && !isAllSelected;

    return (
        <div className="flex flex-col gap-2 filter-components">
            <div className="text-sm text-gray-500 mb-2">{selectedItems.length} selected</div>

            <div className="bg-gray-50 border border-gray-200 rounded overflow-y-auto max-h-[300px]">
                <div className="p-2">
                    {/* "All" checkbox */}
                    <div className="flex items-center py-1 border-b border-gray-200 mb-1">
                        <label className="flex items-center cursor-pointer w-full">
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    className="checkbox-input"
                                    checked={isAllSelected}
                                    onChange={() => handleChange('all')}
                                />
                                <div
                                    className={`checkbox-box ${isAllSelected ? 'checked' : ''} ${
                                        someSelected ? 'indeterminate' : ''
                                    }`}
                                ></div>
                                {(isAllSelected || someSelected) && (
                                    <div className="checkbox-indicator">
                                        {someSelected ? (
                                            <div className="indeterminate-line"></div>
                                        ) : (
                                            <CheckIcon className="w-4 h-4" />
                                        )}
                                    </div>
                                )}
                            </div>
                            <span className="text-sm font-medium">All</span>
                        </label>
                    </div>

                    {/* Option checkboxes */}
                    {options.map((option) => {
                        const isChecked = selectedItems.includes(option);
                        return (
                            <div key={option} className="flex items-center py-1">
                                <label className="flex items-center cursor-pointer w-full">
                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            className="checkbox-input"
                                            checked={isChecked}
                                            onChange={() => handleChange(option)}
                                        />
                                        <div className={`checkbox-box ${isChecked ? 'checked' : ''}`}></div>
                                        {isChecked && (
                                            <div className="checkbox-indicator">
                                                <CheckIcon className="w-4 h-4" />
                                            </div>
                                        )}
                                    </div>
                                    <span className="text-sm">{option}</span>
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export { MultiCheckFilterTW };
